import { useLocation } from "react-router-dom";
import { legalBySlug, CAP_NHAT } from "../data/legalContent.js";
import NotFound from "./NotFound.jsx";

/** Trang tĩnh hoàn toàn — render sẵn lúc build, không cần JavaScript. */
export default function Legal() {
  const { pathname } = useLocation();
  const trang = legalBySlug(pathname.replace(/^\//, ""));
  if (!trang) return <NotFound />;

  return (
    <article className="van-ban">
      <h1>{trang.title}</h1>
      <p className="tom-tat">{trang.tomTat}</p>
      {trang.showDate !== false && (
        <p className="ngay">Cập nhật ngày {CAP_NHAT}</p>
      )}

      {trang.sections.map((s) => (
        <section key={s.h} id={s.id}>
          <h2>{s.h}</h2>
          {s.p.map((doan, i) => (
            <p key={i}>{doan}</p>
          ))}
        </section>
      ))}
    </article>
  );
}
